import React from 'react';

function Mobile() {
  return <div>VehicleCards</div>;
}

export default Mobile;
